import React, { useState } from 'react';
import Sidebar from "../../components/sidebar/Sidebar";
import Navbar from "../../components/navbar/Navbar";

export default function FilterStats() {

    const [result, setResult] = useState('');
    const [products, setProducts] = useState(''); 
    const [orders, setOrders] = useState('');
    const [earns, setEarns] = useState('');   
    
    const [date, setDate] = useState({
        startDate: '',
        endDate: ''
    });

    const handleChange = (event) => {
        setDate({
            ...date,
            [event.target.name]: event.target.value
        });
    };

    const handleFilter = async () => {
        await fetch('http://localhost:8000/users/filterStats', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                start: date.startDate,
                end: date.endDate
            })
        })
            .then((response) => response.json())
            .then((data) => setResult(data));
        
        await fetch('http://localhost:8000/products/filterProducts', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                start: date.startDate,
                end: date.endDate
            })
        })
            .then((response) => response.json())
            .then((data) => setProducts(data));    
        await fetch('http://localhost:8000/order/filterEarns', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                start: date.startDate,
                end: date.endDate
            })
        })
            .then((response) => response.json())
            .then((data) => setEarns(data));
        await fetch('http://localhost:8000/order/filterOrders', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                start: date.startDate,
                end: date.endDate
            })
        })
            .then((response) => response.json())
            .then((data) => setOrders(data));        
    
    };
    console.log(products)
    console.log(orders)
    console.log(earns)    

    const today = new Date().toISOString().split('T')[0];

    return (
        <>
            <div className="home">
                <Sidebar />
                <div className="homeContainer">
                    <Navbar />
                    <br />
                    <form className='container text-center col-lg-3'>
                        <input id='startDate' max={today} onChange={handleChange} value={date.startDate} className='form-control' type='date' name='startDate' />
                        <input id='endDate' max={today} onChange={handleChange} value={date.endDate} className='form-control' type='date' name='endDate' />
                        <button onClick={handleFilter} type='button' className='btn btn-success form-control'>Filter Data</button>
                    </form>
                    <div className="widgets">
                        <h4>Total Users:- {result}</h4>
                        <h4>Total Products:- {products}</h4>
                        <h4>Total Orders:- {orders}</h4>
                        <h4>Total Earns:- ₹{earns}</h4>                        
                    </div>
                </div>
            </div>
        </>
    );
}
